import {
  LOGIN,
  LOGOUT,
  GET_PROFILE,
  UPDATE_PROFILE,
  SET_ENTITLEMENTS,
  SET_ENTITLEMENT_LIST_COUNT,
  INCREMENT_ENTITLEMENT_LIST_COUNT,
  SET_TOKEN,
} from "./ActionTypes";

const initialState = {
  user: null,
  profile: null,
  entitlements: null,
  entitlementUsage: {
    currentListCount: null,
  },
  token: null,
};

export const User = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN: {
      return {
        ...state,
        user: action.payload,
      };
    }
    case GET_PROFILE: {
      return {
        ...state,
        profile: action.payload,
      };
    }
    case UPDATE_PROFILE: {
      return {
        ...state,
        profile: action.payload,
      };
    }
    case SET_ENTITLEMENTS: {
      return {
        ...state,
        entitlements: action.payload || null,
      };
    }
    case SET_ENTITLEMENT_LIST_COUNT: {
      const nextCount = Number(action.payload);
      return {
        ...state,
        entitlementUsage: {
          ...state.entitlementUsage,
          currentListCount:
            Number.isFinite(nextCount) && nextCount >= 0 ? nextCount : null,
        },
      };
    }
    case INCREMENT_ENTITLEMENT_LIST_COUNT: {
      const incrementBy = Number(action.payload);
      const safeIncrementBy =
        Number.isFinite(incrementBy) && incrementBy > 0
          ? Math.trunc(incrementBy)
          : 0;
      const currentCount = Number(state.entitlementUsage?.currentListCount);

      return {
        ...state,
        entitlementUsage: {
          ...state.entitlementUsage,
          currentListCount:
            Number.isFinite(currentCount) && currentCount >= 0
              ? currentCount + safeIncrementBy
              : safeIncrementBy || null,
        },
      };
    }
    case LOGOUT: {
      return {
        ...state,
        user: null,
        profile: null,
        entitlements: null,
        entitlementUsage: {
          currentListCount: null,
        },
      };
    }
    case SET_TOKEN: {
      return {
        ...state,
        token: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

// Auth state for Keycloak
const initialAuthState = {
  isAuthenticated: false,
  keycloak: null,
  isLoading: true,
};

export const Auth = (state = initialAuthState, action) => {
  switch (action.type) {
    case "SET_AUTH":
      return {
        ...state,
        isAuthenticated: action.payload.isAuthenticated,
        keycloak: action.payload.keycloak,
        isLoading: action.payload.isLoading ?? false,
      };
    case "SET_AUTH_LOADING":
      return {
        ...state,
        isLoading: action.payload,
      };
    case LOGOUT:
      return {
        ...initialAuthState,
        isLoading: false,
      };
    default:
      return state;
  }
};
